import { useState } from 'react';
import AccountLayout from '@/components/feature/AccountLayout';

export default function Profile() {
  const [name, setName] = useState('Nguyễn Văn An');
  const [email, setEmail] = useState('an.nguyen@gmail.com');
  const [phone, setPhone] = useState('0901234567');
  const [saved, setSaved] = useState(false);

  return (
    <AccountLayout>
      <div className="max-w-2xl mx-auto">
        <h1 className="text-2xl font-bold text-foreground-950 mb-6">Hồ sơ cá nhân</h1>

        <div className="rounded-xl border border-background-200/60 bg-background-100 p-6">
          <div className="flex items-center gap-4 mb-6">
            <div className="w-16 h-16 rounded-full bg-primary-500/20 flex items-center justify-center">
              <span className="text-xl font-bold text-primary-400">NV</span>
            </div>
            <div>
              <p className="text-base font-semibold text-foreground-950">{name}</p>
              <p className="text-sm text-foreground-600">{email}</p>
              <span className="inline-block mt-1 px-2 py-0.5 rounded-full bg-emerald-500/15 text-emerald-400 text-xs font-semibold">Đã xác minh danh tính</span>
            </div>
          </div>

          <div className="space-y-4">
            <div>
              <label className="block text-xs font-semibold text-foreground-600 mb-1.5">Họ và tên</label>
              <input value={name} onChange={(e) => setName(e.target.value)} className="w-full px-3 py-2.5 rounded-md bg-background-50 border border-background-300/60 text-sm text-foreground-900 focus:outline-none focus:border-primary-500" />
            </div>
            <div>
              <label className="block text-xs font-semibold text-foreground-600 mb-1.5">Email</label>
              <input value={email} onChange={(e) => setEmail(e.target.value)} type="email" className="w-full px-3 py-2.5 rounded-md bg-background-50 border border-background-300/60 text-sm text-foreground-900 focus:outline-none focus:border-primary-500" />
            </div>
            <div>
              <label className="block text-xs font-semibold text-foreground-600 mb-1.5">Số điện thoại</label>
              <input value={phone} onChange={(e) => setPhone(e.target.value)} className="w-full px-3 py-2.5 rounded-md bg-background-50 border border-background-300/60 text-sm text-foreground-900 focus:outline-none focus:border-primary-500" />
            </div>
            <button
              onClick={() => { setSaved(true); setTimeout(() => setSaved(false), 2500); }}
              className="w-full py-3 rounded-md bg-primary-500 text-background-950 font-semibold text-sm hover:bg-primary-600 whitespace-nowrap cursor-pointer transition-colors"
            >
              Lưu thay đổi
            </button>
            {saved && <p className="text-sm text-emerald-400 text-center">Đã lưu thông tin thành công!</p>}
          </div>
        </div>

        <div className="rounded-xl border border-background-200/60 bg-background-100 p-6 mt-6">
          <h2 className="text-base font-semibold text-foreground-950 mb-4">Đổi mật khẩu</h2>
          <div className="space-y-4">
            <div>
              <label className="block text-xs font-semibold text-foreground-600 mb-1.5">Mật khẩu hiện tại</label>
              <input type="password" placeholder="••••••••" className="w-full px-3 py-2.5 rounded-md bg-background-50 border border-background-300/60 text-sm text-foreground-900 focus:outline-none focus:border-primary-500" />
            </div>
            <div>
              <label className="block text-xs font-semibold text-foreground-600 mb-1.5">Mật khẩu mới</label>
              <input type="password" placeholder="••••••••" className="w-full px-3 py-2.5 rounded-md bg-background-50 border border-background-300/60 text-sm text-foreground-900 focus:outline-none focus:border-primary-500" />
            </div>
            <button className="w-full py-3 rounded-md border border-primary-500/50 text-primary-400 font-semibold text-sm hover:bg-primary-500/10 whitespace-nowrap cursor-pointer transition-colors">
              Đổi mật khẩu
            </button>
          </div>
        </div>
      </div>
    </AccountLayout>
  );
}